import { createTheme } from '@mui/material';
import type {} from '@mui/lab/themeAugmentation';
// import './types';

const theme = createTheme({
  typography: {
    fontFamily: 'Work Sans, sans-serif',
  },
  palette: {
    primary: {
      main: '#2057A6',
    },
    secondary: {
      main: '#131836',
    },
    text: {
      primary: '#293139',
      disabled: '#72777C',
    },
    info: {
      main: '#027CBF',
      contrastText: '#FFFFFF',
    },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled input::placeholder': {
            color: '#72777C',
            opacity: 1,
            WebkitTextFillColor: '#72777C',
          },
        },
        input: {
          '&::placeholder': {
            color: '#72777C',
            opacity: 1,
          },
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            boxShadow: 'none',
          },
          '&.Mui-focusVisible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            boxShadow: 'none !important',
          },
          '&:focus-visible::after': {
            opacity: 0,
          },
          '&.Mui-focusVisible::after': {
            opacity: 0,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#fff',
          borderRadius: '5px',
          textTransform: 'none',
          fontWeight: 'bold',
          fontSize: '18px',
          padding: '10px',
          '&:focus-visible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            boxShadow: 'none',
          },
          '&:focus-visible::after': {
            opacity: 0,
          },
          '&.Mui-focusVisible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            boxShadow: 'none',
          },
          '&.Mui-focusVisible::after': {
            opacity: 0,
          },
        },
        contained: {
          '&:focus-visible': {
            color: '#FFFFFF',
            boxShadow: 'none',
          },
          '&.Mui-focusVisible': {
            color: '#FFFFFF',
            boxShadow: 'none',
          },
        },
        containedPrimary: {
          '&:focus-visible': {
            color: '#FFFFFF !important',
            backgroundColor: '#2057A6 !important',
            boxShadow: 'none !important',
          },
          '&.Mui-focusVisible': {
            color: '#FFFFFF !important',
            backgroundColor: '#2057A6 !important',
            boxShadow: 'none !important',
          },
          '&:focus-visible::after': {
            opacity: '0 !important',
          },
          '&.Mui-focusVisible::after': {
            opacity: '0 !important',
          },
        },
        outlined: {
          color: '#2057A6',
          '&:focus-visible': {
            backgroundColor: 'transparent',
            color: '#2057A6',
            boxShadow: 'none',
          },
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent !important',
            color: '#2057A6 !important',
            boxShadow: 'none !important',
          },
          '&:focus-visible::after': {
            opacity: '0 !important',
          },
          '&.Mui-focusVisible::after': {
            opacity: '0 !important',
          },
        },
        outlinedPrimary: {
          '&:focus-visible': {
            backgroundColor: 'transparent',
            color: '#2057A6',
            borderColor: '#2057A6',
          },
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent !important',
            color: '#2057A6 !important',
            borderColor: '#2057A6 !important',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
          '&:focus-visible::after': {
            opacity: 0,
          },
          '&.Mui-focusVisible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            backgroundColor: 'transparent !important',
            boxShadow: 'none !important',
          },
          '&.Mui-focusVisible::after': {
            opacity: '0 !important',
          },
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          '&:focus:not(.Mui-selected)': {
            backgroundColor: 'transparent',
          },
          '&:focus-visible:not(.Mui-selected)': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
          '&.Mui-focusVisible:not(.Mui-selected)': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            backgroundColor: 'transparent !important',
            boxShadow: 'none !important',
          },
          '&:focus-visible:not(.Mui-selected)::after, &.Mui-focusVisible:not(.Mui-selected)::after': {
            opacity: 0,
          },
          '&.Mui-selected': {
            '&:focus, &:focus-visible, &.Mui-focusVisible': {
              color: '#FFFFFF',
              backgroundColor: '#2057A6',
              outline: '2px solid #153760',
              outlineOffset: '-2px',
              boxShadow: 'none',
            },
            '&.Mui-focusVisible': {
              color: '#FFFFFF !important',
              backgroundColor: '#2057A6 !important',
            },
            '&:focus-visible::after, &.Mui-focusVisible::after': {
              opacity: '1 !important',
            },
          },
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          '&:focus:not(.Mui-selected)': {
            backgroundColor: 'transparent',
          },
          '&:focus-visible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            boxShadow: 'none',
          },
          '&.Mui-focusVisible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            boxShadow: 'none !important',
          },
          '&:focus-visible:not(.Mui-selected)': {
            backgroundColor: 'transparent',
            color: '#2057A6',
          },
          '&.Mui-focusVisible:not(.Mui-selected)': {
            backgroundColor: 'transparent !important',
            color: '#2057A6 !important',
          },
          '&:focus-visible::after': {
            opacity: 0,
          },
          '&.Mui-focusVisible::after': {
            opacity: '0 !important',
          },
        },
        selected: {
          '&:focus': {
            color: '#FFFFFF',
            backgroundColor: '#2057A6',
          },
          '&:focus-visible': {
            color: '#FFFFFF',
            backgroundColor: '#2057A6',
            outline: '2px solid #153760',
            outlineOffset: '2px',
          },
          '&.Mui-focusVisible': {
            color: '#FFFFFF !important',
            backgroundColor: '#2057A6 !important',
            outline: '2px solid #153760',
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focusVisible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
          },
          '&:has(.MuiSelect-select:focus-visible)': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          '&:focus-visible': {
            outline: 'none',
          },
          '&.Mui-focusVisible': {
            outline: 'none',
          },
        },
        outlined: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2057A6',
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
          },
          '&.Mui-focusVisible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          '&:has(.MuiRadio-root.Mui-focusVisible), &:has(.MuiRadio-root:focus-visible)': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            borderRadius: '12px',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:focus:not(.Mui-selected)': {
            backgroundColor: 'transparent',
          },
          '&:focus-visible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            boxShadow: 'none',
          },
          '&.Mui-focusVisible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            boxShadow: 'none !important',
          },
          '&:focus-visible:not(.Mui-selected)': {
            backgroundColor: 'transparent !important',
          },
          '&.Mui-focusVisible:not(.Mui-selected)': {
            backgroundColor: 'transparent !important',
          },
          '&:focus-visible::after': {
            opacity: 0,
          },
          '&.Mui-focusVisible::after': {
            opacity: '0 !important',
          },
        },
        selected: {
          '&:focus-visible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            backgroundColor: 'rgba(51, 127, 201, 0.12)',
          },
          '&.Mui-focusVisible': {
            outline: '2px solid #153760',
            outlineOffset: '2px',
            backgroundColor: 'rgba(51, 127, 201, 0.12) !important',
          },
        },
      },
    },
  },
});

export default theme;
